import { useEffect, useRef, useState } from 'react';

export const useInView = () => {
  const ref = useRef(null);
  const [v, setV] = useState(false);

  useEffect(() => {
    const currentRef = ref.current;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setV(true);
          obs.unobserve(e.target);
        }
      },
      { threshold: 0.1 }
    );

    if (currentRef) obs.observe(currentRef);

    return () => {
      if (currentRef) obs.unobserve(currentRef);
    };
  }, []);

  return { ref, v };
};